export enum PathwayBuilderTab {
  Questions = 'questions',
  Pathways = 'pathways'
}

export enum PathwayBuilderTabName {
  Questions = 'Question Bank',
  Pathways = 'Pathways'
}
